<template>
	<div>
		<v-row class="font-weight-medium" style="font-size: 18px">
			<v-col class="mt-6">
				<div>ID: {{ pratica.custom_id }}</div>
				<div>Ragione Sociale Cliente: {{ pratica.accordo.cliente.ragione_sociale }}</div>
				<div>Cognome Cliente: {{ pratica.accordo.cliente.cognome }}</div>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-progress-linear
					v-if="isLoadingPraticaTags || isDetachingTag"
					indeterminate
					color="primary"
				></v-progress-linear>
				<div
					v-else-if="praticaTags.length == 0"
					class="font-weight-medium primary--text text-h6"
				>
					Nessun Tag
				</div>
				<template
					v-else
					v-for="tag in praticaTags"
				>
					<v-text-field
						v-model="tag.text"
						outlined
						dense
						readonly
						append-icon="mdi-trash-can-outline"
						@click:append="detachTag(tag)"
						:disabled="syncInProgress"
					></v-text-field>
				</template>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<v-form ref="newOrSelectedTagForm">
					<v-combobox
						ref="newOrSelectedTagCombobox"
						v-model="newOrSelectedTag"
						:items="allTags"
						:loading="isLoadingAllTags"
						:disabled="isLoadingAllTags || syncInProgress || isDetachingTag"
						:search-input.sync="searchTag"
						autocomplete="nope"
						clearable
						dense
						item-text="text"
						item-value="id"
						label="Tags"
						outlined
						return-object
					></v-combobox>
				</v-form>
			</v-col>
			<v-col>
				<v-btn
					color="secondary"
					@click="syncTags()"
					:loading="syncInProgress"
				>
					Aggiungi Tag
				</v-btn>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import { eventBus } from "@/event-bus";
export default {
	props: ['pratica'],
	data() {
		return {
			isLoadingAllTags: false,
			isLoadingPraticaTags: false,
			praticaTags: [],
			searchTag: null,
			allTags: [],
			newOrSelectedTag: null, // può essere stringa se è stato scritto a mano un nuovo tag, oppure un oggetto
			syncInProgress: false,
			isDetachingTag: false
		}
	},
	
	created() {
		this.getPraticaTags();
		this.getAllTags();
	},
	
	computed: {
		isLoading() {
			return this.syncInProgress
				|| this.isDetachingTag;
		}
	},
	
	watch: {
		isLoading(boolean) {
			this.$emit('is-loading', boolean)
		}
	},
	
	methods: {
		getAllTags() {
			this.isLoadingAllTags = true;
			axios.get(`/api/tags?without_tags_of_this_pratica_id=${this.pratica.id}`)
				.then(response => {
					this.allTags = response.data;
					
					// rimuovo i tags già assegnati alla pratica
					// this.praticaTags.forEach(praticaTag => {
					// 	this.$delete(this.allTags, this.allTags.findIndex(tag => tag.id == praticaTag.id));
					// })
				})
				.finally(() => {
					this.isLoadingAllTags = false;
				})
		},
		getPraticaTags() {
			this.isLoadingPraticaTags = true;
			return axios.get(`/api/tags`, {
				params: {
					pratica_id: this.pratica.id
				}
			})
				.then(response => {
					this.praticaTags = response.data;
				})
				.finally(() => {
					this.isLoadingPraticaTags = false;
				})
		},
		syncTags() {
			this.$refs.newOrSelectedTagCombobox.blur();
			this.$nextTick(() => {
				if (this.newOrSelectedTag === null) return;
				
				this.syncInProgress = true;
				
				let newTag = null;
				let praticaTags = Object.assign([], this.praticaTags);
				
				// se
				if (typeof this.newOrSelectedTag == 'string') newTag = this.newOrSelectedTag;
				else praticaTags.push(this.newOrSelectedTag);
				
				console.log(this.newOrSelectedTag)
				
				axios.post('/api/tags/sync', {
					type: 'pratica',
					pratica_id: this.pratica.id,
					new_tag: newTag,
					pratica_tags: praticaTags
				})
					.then(() => {
						this.newOrSelectedTag = null;
						this.$emit('tags-updated', {
							pratica: this.pratica,
							callAxios: true
						})
						this.getPraticaTags();
						this.getAllTags();
					})
					.finally(() => {
						this.syncInProgress = false;
					})
			})
		},
		detachTag(tag) {
			this.isDetachingTag = true;
			this.$delete(this.praticaTags, this.praticaTags.findIndex((praticaTag) => praticaTag.id == tag.id));
			
			axios.post('/api/tags/sync', {
				type: 'pratica',
				pratica_id: this.pratica.id,
				pratica_tags: this.praticaTags
			})
				.then(() => {
					this.$emit('tags-updated', {
						pratica: this.pratica,
						callAxios: true
					})
					this.getPraticaTags();
					this.getAllTags();
				})
				.finally(() => {
					this.isDetachingTag = false;
				})
		}
	}
}
</script>